import React from 'react';
import InputField from '../../Forms/Input/InputField';
import {
  getSaleCopiesValidationError,
  MAX_SALE_COPIES,
  MIN_SALE_COPIES,
} from '../../../features/printer/printerSaleCopies';

interface Props {
  value: number;
  onChange: (value: number) => void;
}

const PrinterSaleCopiesField: React.FC<Props> = ({ value, onChange }) => (
  <div>
    <InputField
      label="Copias de comprobante de venta"
      name="saleCopies"
      iconKey="printer"
      value={value}
      onChange={(event) => onChange(Number(event.target.value))}
      type="number"
      min={MIN_SALE_COPIES}
      max={MAX_SALE_COPIES}
      step="1"
      required
      error={getSaleCopiesValidationError(value)}
    />
    <p className="-mt-4 mb-5 text-xs text-slate-500 dark:text-slate-400">
      Cantidad de comprobantes idénticos que se imprimirán al completar una venta.
    </p>
  </div>
);

export default PrinterSaleCopiesField;
